import React, { useEffect } from 'react';
import { flushAnalyticsQueue } from '../../utils/analytics';
import { isAnalyticsEnvironment } from '../../utils/analyticsConsent';
import { isProductAnalyticsEnabled } from '../../utils/productAnalytics';

const TRACKER_SCRIPT_ID = 'hesychia-tianji-tracker';
const GTAG_SCRIPT_ID = 'hesychia-gtag';
const GTAG_ID = 'G-V12DLRLPWR';

function loadGoogleTag(): void {
  if (document.getElementById(GTAG_SCRIPT_ID)) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GTAG_ID);

  const script = document.createElement('script');
  script.id = GTAG_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(script);
}

/**
 * Loads Tianji tracker.js for automatic page views on prod/beta builds.
 * Page views always run (no consent gate). Custom events use analytics.ts + consent.
 */
const Tracker: React.FC = () => {
  useEffect(() => {
    if (isProductAnalyticsEnabled()) {
      loadGoogleTag();
    }

    const websiteId = process.env.REACT_APP_TIANJI_WEBSITE_ID || '';
    if (isAnalyticsEnvironment() && websiteId && !document.getElementById(TRACKER_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = TRACKER_SCRIPT_ID;
      script.src = 'https://tianji.aimloperations.com/tracker.js';
      script.async = true;
      script.defer = true;
      script.setAttribute('data-website-id', websiteId);
      script.setAttribute('data-do-not-track', 'true');
      script.onload = () => {
        flushAnalyticsQueue();
      };

      document.body.appendChild(script);
    }

    return () => {
      const loaded = document.getElementById(TRACKER_SCRIPT_ID);
      if (loaded?.parentNode) {
        loaded.parentNode.removeChild(loaded);
      }
      const gtag = document.getElementById(GTAG_SCRIPT_ID);
      if (gtag?.parentNode) {
        gtag.parentNode.removeChild(gtag);
      }
    };
  }, []);

  return null;
};

export default Tracker;
